<Dialog :header="isNewMessage ? 'Nieuw bericht' : 'Bericht'" v-model:visible="visibleModel" modal>
    <form>
        <div class="aeg-flex-rows-layout">
            <div class="aeg-flex-row">
                <aeg-field-validation-wrapper :error-message="errors.dateFrom" mod-required name="Begindatum"
                                              #default="{hasErrors}">
                    <DatePicker v-model="dateFrom" v-bind="dateFromProps"
                                :invalid="hasErrors" show-icon show-time hide-on-date-time-select id="date-from"/>
                </aeg-field-validation-wrapper>
                <aeg-field-validation-wrapper :error-message="errors.dateTo" name="Einddatum"
                                              #default="{hasErrors}">
                    <DatePicker v-model="dateTo" v-bind="dateToProps" show-icon show-time hide-on-date-time-select
                                id="date-to"/>
                </aeg-field-validation-wrapper>
            </div>
            <aeg-field-validation-wrapper :error-message="errors.title" mod-required name="Titel"
                                          #default="{hasErrors}">
                <InputText name="title" v-model="title" v-bind="titleProps" :invalid="hasErrors"/>
            </aeg-field-validation-wrapper>
            <aeg-field-validation-wrapper :error-message="errors.message" mod-required name="Bericht"
                                          #default="{hasErrors}">
                <Textarea rows="6" name="text" id="text" v-model="message" v-bind="messageProps"
                             :invalid="hasErrors"/>
            </aeg-field-validation-wrapper>
            <div class="aeg-label-above-layout">
                <label>Preview</label>
<!--                TODO: titel?-->
                <Message severity="warn">
                    <div v-html="message"></div>
                </Message>
            </div>
        </div>
    </form>

    <template v-slot:footer>
        <Button :disabled="invalidForm" type="submit" @click="onSubmit">Bewaren</Button>
        <Button v-if="!isNewMessage"
                :disabled="isDeletingAnnouncement"
                @click.prevent="removeAnnouncement"
                severity="danger" >
            Verwijderen
        </Button>
        <aeg-cancel-button @click="onCloseModal" />
    </template>
</Dialog>
